import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";

import { attendance } from "../api/attendance";

export const useSendCheckIn = (): {
  isPending: boolean;
  mutateAsync: (value: FormData) => Promise<any>;
} => {
  const { isPending, mutateAsync } = useMutation({
    mutationFn: (value: FormData) => attendance.sendIn(value),
    onSuccess: () => {
      toast.success("Hush kelibsiz!", {
        position: "top-center",
      });
    },
    onError: (err: any) => {
      toast.error(err.response.data.detail, {
        position: "top-center",
      });
    },
  });

  return { isPending, mutateAsync };
};
